import { UPDATE_PROCEDIMENTO, RESET_PROCEDIMENTO } from '../actions'

export default function (state = {}, action) {
  switch (action.type) {
    case UPDATE_PROCEDIMENTO:
      return action.payload
    case RESET_PROCEDIMENTO:
      return null
    default:
      return state
  }
}
